import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

function AnimalDeerMale() {
  return (
    <ItemPresenter imagePath={"/images/animals/deerMale.png"} bottomLabel={"Veado macho"}
      customImageWidth={" "}
      />
  );
}

export default AnimalDeerMale;